module.exports = __webpack_public_path__ + "static/img/1028.f117b88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1028.jpg
// module id = 210
// module chunks = 0